import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import { routes } from '../../../../consts'

const SomethingWentWrongDialog = () => {
  const dispatch = useDispatch()
  const isSomethingWentWrongDialogVisible = useSelector(
    state => state.payment.isSomethingWentWrongDialogVisible
  )

  const backToHome = () => {
    dispatch(Actions.createAction(Actions.DISABLE_SOMETHING_WENT_WRONG_DIALOG))
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
  }

  const somethingWentWrongActions = [
    <Button
      key="2"
      className="dialog-action"
      type="secondary"
      onClick={() => {
        backToHome()
      }}
    >
      {$t('somethingWentWrongDialog.home')}
    </Button>,
  ]

  return (
    <>
      <Dialog
        title={$t('somethingWentWrongDialog.title')}
        isVisible={isSomethingWentWrongDialogVisible}
        footerActions={somethingWentWrongActions}
        onCancel={backToHome}
        className="declare-location-dialog"
      >
        <div className="dialog-content">
          <div className="subtitle">{$t('somethingWentWrongDialog.desc')}</div>
        </div>
      </Dialog>
    </>
  )
}

export default SomethingWentWrongDialog
